import React from "react"

export const SmallHeader = () => {
  return <div></div>
}
